import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/consumer-Insight.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/consumer.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/market-analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/patient-insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/product_testing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
